import React from 'react'
import issue_data from "../assets/data/component_issue.json"

const ComponentsIssues = () => {

    const renderSection = (list, heading) => {
        if(!list) return
        return (
            <div className='issue-section'>
                <strong>{heading}</strong>
                <ul>{list.map(item => <li>{item}</li>)}</ul>
            </div>
        )
    }
    return (
        <div>
            <h2>List of ComponentsIssues and its Issues if breaks</h2>
            <ul>
                {issue_data.map((item, i) => {
                    return <li>
                        <h4>({i+1}) {item.inspection_section}</h4>
                        <div className='issue-group df'>
                            {renderSection(item.current_issue, "Current Issue")}
                            {renderSection(item.future_issue, "Future Issue")}
                            {renderSection(item.activity_need, "Activity Needed")}
                            {renderSection(item.required_components, "Required Components")}
                        </div>
                    </li>
                })}
            </ul>
        </div>
    )
}

export default ComponentsIssues